import type {ApiService} from "~/services/ApiService";
import type {Widget} from "~~/api/models";

export class WidgetService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async getWidgets(): Promise<Widget[]> {
    return this.apiService.get<Widget[]>("/api/widget");
  }

  async getWidgetCount(tenants: string[], widgetId: string): Promise<number> {
    return this.apiService.get(`/api/widget/${widgetId}/count`, {
      headers: {
        'x-tenant-id': tenants.join(';'),
      }
    });
  }

  async getWidgetCounts(tenants: string[]): Promise<Record<string, number>[]> {
    return this.apiService.get<Record<string, number>[]>(`/api/widget/count`, {
      headers: {
        'x-tenant-id': tenants.join(';'),
      }
    });
  }
}